<template>
  <v-card class="my-1">
    <v-toolbar flat dense>
      <v-toolbar-title>Rechtliches</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="legal-row">
        <div class="legal-field">
          <div class="d-flex align-center mb-1">
            <v-icon small class="mr-1">{{ mdiShieldOutline }}</v-icon>
            <span class="text-body-2 font-weight-medium">Datenschutz</span>
            <v-tooltip bottom max-width="280">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
              </template>
              <span>URL zur Datenschutzerklärung Ihrer Organisation, verlinkt aus der App.</span>
            </v-tooltip>
          </div>
          <div class="d-flex align-center">
            <v-text-field
              :id="'id-'+privacyUrl.key"
              type="url"
              :value="privacyUrl.currentValue"
              @input="val => $emit('input', { key: privacyUrl.key, value: val && val.trim() !== '' ? val : null })"
              outlined
              dense
              hide-details="auto"
              :rules="webUrlRules"
              autocomplete="off"
            ></v-text-field>
            <reset-icon :setting="privacyUrl" @clear="$emit('clear', privacyUrl.key)" @set-here="$emit('set-here', privacyUrl.key)" />
          </div>
        </div>
        <div class="legal-field">
          <div class="d-flex align-center mb-1">
            <v-icon small class="mr-1">{{ mdiFileDocumentOutline }}</v-icon>
            <span class="text-body-2 font-weight-medium">Impressum</span>
            <v-tooltip bottom max-width="280">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
              </template>
              <span>URL zum Impressum Ihrer Organisation, verlinkt aus der App.</span>
            </v-tooltip>
          </div>
          <div class="d-flex align-center">
            <v-text-field
              :id="'id-'+imprintUrl.key"
              type="url"
              :value="imprintUrl.currentValue"
              @input="val => $emit('input', { key: imprintUrl.key, value: val })"
              outlined
              dense
              hide-details="auto"
              :rules="webUrlRules"
              autocomplete="off"
            ></v-text-field>
            <reset-icon :setting="imprintUrl" @clear="$emit('clear', imprintUrl.key)" @set-here="$emit('set-here', imprintUrl.key)" />
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiInformationOutline, mdiShieldOutline, mdiFileDocumentOutline } from '@mdi/js'
import ResetIcon from '@/components/device/ResetIcon'

export default {
  name: 'LegalGroup',
  components: { ResetIcon },
  props: {
    privacyUrl: {
      type: Object,
      required: true,
    },
    imprintUrl: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      mdiInformationOutline,
      mdiShieldOutline,
      mdiFileDocumentOutline,
      webUrlRules: [
        (v) => (!v || (/^https?:\/\/[^/]{3,}/.test(v) || 'Gültige URL eingeben (https://...)'))
      ],
    }
  },
}
</script>

<style scoped>
.legal-row {
  display: flex;
  gap: 20px;
}
.legal-field {
  flex: 1;
}
</style>
